import { inject, provideAppInitializer } from "@angular/core";
import { filter, first, switchMap } from "rxjs/operators";
import { UserAccessRegulatorService } from "./shared/services/user-access-regulator.service";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { BuildVersionService } from "./b2b/ops/shared/services/build-version.service";

export const AppSetupProvider = provideAppInitializer(() => {
  const initializerFn = initialAppSetup(
    inject(UserAccessRegulatorService),
    inject(MsalService),
    inject(MsalBroadcastService),
    inject(BuildVersionService),
  );
  return initializerFn();
});

function initialAppSetup(
  userAccessRegulator: UserAccessRegulatorService,
  msalService: MsalService,
  msalBroadcastService: MsalBroadcastService,
  buildVersionService: BuildVersionService,
) {
  return () =>
    initialAccessRegulatorSetup(
      userAccessRegulator,
      msalService,
      msalBroadcastService,
      buildVersionService,
    ).pipe(
      switchMap(() => userAccessRegulator.getUserEmailVerify()),
      first(),
    );
}

function initialAccessRegulatorSetup(
  userAccessRegulator: UserAccessRegulatorService,
  msalService: MsalService,
  msalBroadcastService: MsalBroadcastService,
  buildVersionService: BuildVersionService,
) {
  return msalService.handleRedirectObservable().pipe(
    switchMap(() => msalBroadcastService.inProgress$),
    filter((status) => status === InteractionStatus.None),
    switchMap(() => userAccessRegulator.initAccessorRoles()),
    switchMap(() => buildVersionService.initVersion()),
  );
}
